<div class='shows'>
  <h1>Medewerkers</h1>
  <p>L-FM is gestopt als gemeentezender voor de gemeente Landerd. Online gaat de zender echter door als een non-stop zender.<br>
    Momenteel verzorgt L-FM.nl geen live uitzendingen. Er zijn daarom ook geen DJ's aanwezig.<br>
    <br>
    Het format wordt beheerd door Mari Brouwer<br>
    De techniek en infrastructuur wordt beheerd door Martijn Brouwer
  </p>
</div>
